const UN_AUTHENTICATED_ROUTES = {
  SIGNUP_PASSWORD: (email) => `/signup-password?email=${email}`,
  VERIFY_EMAIL: (email) => `/verify-email?email=${email}`,
  LOGIN_PASSWORD: (email) => `/login-password?email=${email}`,
  LINK_ACCOUNT: (email, provider) => `/link-account?email=${email}&provider=${provider}`
};

const AUTH_STATES = {
  LOGIN: 1,
  SIGNUP: 2,
  FORGOT_PASSWORD: 5,
  EMAIL_SENT: 6,
  RESET_PASSWORD: 7,
  CONGRATULATION: 8,
  OTP_VERIFY: 10,
  LINK_ACCOUNT: 13,
  VERIFY_EMAIL: 12
};

export { UN_AUTHENTICATED_ROUTES, AUTH_STATES }; 